export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12296.b2f648a6.jpg";